import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const templates = [
  {
    id: "student-dev",
    title: "Student Developer",
    description: "Showcase your skills, GitHub, and projects in a clean and minimal style.",
    image: "/templates/student-dev.png",
    demoUrl: "/templates/student-dev",
  },
  {
    id: "photographer",
    title: "Photographer / Artist",
    description: "A visual grid-based template to showcase your creative portfolio.",
    image: "/templates/photographer.png",
    demoUrl: "/templates/photographer",
  },
  {
    id: "freelancer",
    title: "Freelancer Resume",
    description: "Perfect for freelancers to display services, reviews, and pricing.",
    image: "/templates/freelancer.png",
    demoUrl: "/templates/freelancer",
  },
  {
    id: "startup-founder",
    title: "Startup Founder Mini Site",
    description: "Highlight your idea, team, vision and social links like a startup profile.",
    image: "/templates/startup-founder.png",
    demoUrl: "/templates/startup-founder",
  },
];

export default function Templates() {
  return (
    <div className="relative min-h-screen px-6 py-16 bg-white text-black dark:bg-background dark:text-white overflow-hidden transition-all duration-300">
      {/* Glowing background layer */}
      <div className="absolute inset-0 z-0 blur-3xl animate-pulse bg-gradient-to-br from-hoverBlue/10 via-primary/10 to-transparent" />

      {/* Title */}
      <h2 className="relative z-10 text-4xl md:text-5xl font-bold text-center mb-12 text-primary dark:text-hoverBlue">
        Choose a Template
      </h2>

      {/* Template Cards Grid */}
      <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {templates.map((template, i) => (
          <motion.div
            key={template.id}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            className="rounded-3xl p-6 border shadow-md transition-all duration-300
              bg-gray-100 text-black border-gray-300 hover:shadow-primary/30
              dark:bg-[#1c1c1e] dark:text-white dark:border-[#333] dark:hover:shadow-hoverBlue/30"
          >
            <img
              src={template.image}
              alt={template.title}
              className="w-full h-48 object-cover rounded-xl mb-4 border border-gray-300 dark:border-[#2a2a2a]"
            />
            <h3 className="text-2xl font-bold text-primary dark:text-hoverBlue">{template.title}</h3>
            <p className="mt-2 text-sm text-gray-700 dark:text-gray-400">{template.description}</p>

            <div className="flex gap-4 mt-6 flex-wrap">
              <Link
                to={template.demoUrl}
                className="px-4 py-2 rounded-full bg-primary text-white hover:bg-buttonHover transition"
              >
                Preview Demo
              </Link>
              <Link
                to={`/get-started?template=${template.id}`}
                className="px-4 py-2 rounded-full bg-hoverBlue text-black hover:bg-[#33b5ff] transition"
              >
                Use This Template
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
